import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_017.jpg';
page.images = [
  {
    imageId: 'page017_zoom0',
    rectangle: {
      x: 976,
      y: 1932,
      width: 810,
      height: 340,
    },
    imageSrc: 'images/page017/017 4.jpg',
  },
  {
    imageId: 'page017_zoom1',
    rectangle: {
      x: 976,
      y: 1548,
      width: 810,
      height: 376,
    },
    imageSrc: 'images/page017/017 3.jpg',
  },
  {
    imageId: 'page017_zoom2',
    rectangle: {
      x: 606,
      y: 845,
      width: 1178,
      height: 662,
    },
    imageSrc: 'images/page017/017 2.jpg',
  },
  {
    imageId: 'page017_zoom3',
    rectangle: {
      x: 606,
      y: 148 + 145,
      width: 1178,
      height: 680 - 145,
    },
    imageSrc: 'images/page017/017 1.jpg',
  },
];
page.games = [
  {
    id: 'page017_game12',
    icon: 'ikonaStepbystep',
    color: '#FF000000',
    pos: {
      x: RIGHT,
      y: 1540,
    },
    item: {
      id: 'page017_game12',
    },
    rectangle: {
      id: 'page017_rect2',
    },
  },
  {
    id: 'page017_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 958,
    },
    item: {
      id: 'page017_game11',
    },
    rectangle: {
      id: 'page017_rect1',
    },
  },
  {
    id: 'page017_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 303,
    },
    item: {
      id: 'page017_game10',
    },
    rectangle: {
      id: 'page017_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page017_rect0',

    tooltip: '',

    linked: ['page017_game10'],
    x: 131,
    y: 303,
    width: 430,
    height: 571,
  },
  {
    id: 'page017_rect1',

    tooltip: '',

    linked: ['page017_game11'],
    x: 130,
    y: 958,
    width: 430,
    height: 564,
  },
  {
    id: 'page017_rect2',

    tooltip: '',
    color: '#FF000000',
    linked: ['page017_game12'],
    x: 129,
    y: 1540,
    width: 813,
    height: 804,
  },
];
export default page;
